import { Reducer } from 'react';
import { IActionPayload } from 'types';
import { createPagination } from '@cloudez/cloudez-design-system';
import { DatabaseListingState } from './state';

const reducer: Reducer<DatabaseListingState, IActionPayload> = (
  state,
  action,
): DatabaseListingState => {
  switch (action.type) {
    case 'GET_DATABASES':
      const databases = action.payload.results;

      const pagination = createPagination(action.payload, 10);

      return {
        ...state,
        databases,
        ...pagination,
      };

    case 'UPDATE_DATABASE': {
      return {
        ...state,
        databases: state?.databases?.map(database =>
          database.id === action.payload.id ? action.payload : database,
        ),
      };
    }

    case 'UPDATE_DATABASE_FIELD': {
      return {
        ...state,
        databases: state?.databases?.map(database =>
          database.id === action.payload.id
            ? {
                ...database,
                [action.payload.field]: action.payload.value,
              }
            : database,
        ),
      };
    }

    case 'SET_LOADING': {
      return {
        ...state,
        loading: action.payload,
      };
    }

    case 'SET_ERRORS': {
      return {
        ...state,
        errors: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export default reducer;
